import React from 'react';
import { type LucideProps } from 'lucide-react';

const AccountIcon = (props: LucideProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5928 3.02719C14.6806 2.04234 13.4065 1.5 12.0003 1.5C10.5865 1.5 9.30824 2.03906 8.40027 3.01781C7.48246 4.00734 7.03527 5.35219 7.14027 6.80438C7.34839 9.66938 9.52855 12 12.0003 12C14.472 12 16.6484 9.66984 16.8598 6.80531C16.9662 5.36625 16.5162 4.02422 15.5928 3.02719Z"
        fill="currentColor"
      />
      <path
        d="M20.2503 22.5H3.75027C3.31289 22.5057 2.89622 22.3141 2.61589 21.9783C2.31121 21.6141 2.18839 21.1167 2.27933 20.6138C2.67496 18.4191 3.90964 16.5755 5.85027 15.2812C7.57433 14.1323 9.75824 13.5 12.0003 13.5C14.2423 13.5 16.4262 14.1328 18.1503 15.2812C20.0909 16.575 21.3256 18.4186 21.7212 20.6133C21.8121 21.1162 21.6893 21.6136 21.3846 21.9778C21.1044 22.3138 20.6877 22.5056 20.2503 22.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AccountIcon;
